
import axios from 'axios'
import { url } from './url'

function getFaultTypes() {
    var urlString = `${url}/fault-types`;
    return axios
        .get(urlString)
        .then(res => res.data);
}

export default {
    getFaultTypes    
};